import { render, staticRenderFns } from "./DashboardChicksBySex.vue?vue&type=template&id=76b930a1&scoped=true"
import script from "./DashboardChicksBySex.vue?vue&type=script&lang=js"
export * from "./DashboardChicksBySex.vue?vue&type=script&lang=js"
import style0 from "./DashboardChicksBySex.vue?vue&type=style&index=0&id=76b930a1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b930a1",
  null
  
)

export default component.exports